/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { routePage } from '../store/route-page';
import ListHeader from './ListHeader';
import Cell from './Cell';
import AddToListCell from './AddToListCell';

class List extends Component {
  static onDragEnd({ source, destination }) {
    if (destination !== null && destination.index !== source.index) {
      if (source.index === routePage.orderAtIndex) {
        routePage.orderAtIndex = destination.index;
      } else if (source.index === routePage.orderAtIndex - 1 && destination.index === routePage.orderAtIndex) {
        routePage.orderAtIndex -= 1;
      } else if (source.index === routePage.orderAtIndex + 1 && destination.index === routePage.orderAtIndex) {
        routePage.orderAtIndex += 1;
      } else {
        const fromIndex = source.index >= routePage.orderAtIndex ? source.index - 1 : source.index;
        const toIndex = destination.index >= routePage.orderAtIndex ? destination.index - 1 : destination.index;
        routePage.reorderAddress({ fromIndex, toIndex });
      }
    }
  }

  static onDelete(key) {
    routePage.unorderAddresses({ keys: [key] });
  }

  render() {
    const { orderedAddresses, orderAtIndex } = routePage;
    return (
      <DragDropContext onDragEnd={List.onDragEnd}>
        <ListHeader/>
        <Droppable droppableId="orderedDroppable">
          {dropProvided => (
            <div ref={dropProvided.innerRef} {...dropProvided.droppableProps}>
              {orderedAddresses.slice(0, orderAtIndex).map((address, index) => (
                <Draggable key={address.key} draggableId={address.key} index={index} isDragDisabled={!routePage.editable}>
                  {dragProvided => <Cell provided={dragProvided} address={address} onDelete={List.onDelete}/>}
                </Draggable>
              ))}
              <Draggable key={List.orderAtIndexKey} draggableId={List.orderAtIndexKey} index={orderAtIndex} isDragDisabled={!routePage.editable}>
                {dragProvided => <AddToListCell provided={dragProvided}/>}
              </Draggable>
              {orderedAddresses.slice(orderAtIndex).map((address, index) => (
                <Draggable key={address.key} draggableId={address.key} index={index + orderAtIndex + 1} isDragDisabled={!routePage.editable}>
                  {dragProvided => <Cell provided={dragProvided} address={address} onDelete={List.onDelete}/>}
                </Draggable>
              ))}
              {dropProvided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }
}

List.orderAtIndexKey = 'orderAtIndexKey';

export default observer(List);



// WEBPACK FOOTER //
// ./src/components/List.js